module.exports = __webpack_public_path__ + "img/cww_15.6a4530aa.jpg";